export default function Hero({ children, gradient = '', bg = '', className = 'py-24 z-10' }) {
  return (
    <div className={`relative ${bg} bg-top bg-no-repeat bg-cover w-full`}>
      <div className={`${gradient}`}>
        <div className="container mx-auto">
          <div className={className}>{children}</div>
        </div>
      </div>
    </div>
  );
}
